import { Amplify } from "aws-amplify";
import { confirmSignIn, fetchAuthSession, signIn, signInWithRedirect, signOut, signUp, } from "aws-amplify/auth";
export class AmplifyClient {
    constructor(config) {
        Amplify.configure({
            Auth: {
                Cognito: {
                    userPoolId: config.cognitoUserPoolId,
                    userPoolClientId: config.cognitoClientId,
                    signUpVerificationMethod: "code",
                    loginWith: {
                        oauth: {
                            domain: config.cognitoDomain,
                            scopes: config.cognitoScopes,
                            redirectSignIn: [config.signInRedirectUrl],
                            redirectSignOut: [config.signOutRedirectUrl],
                            responseType: "code",
                            providers: config.cognitoProviders,
                        },
                    },
                },
            },
        });
    }
    async getAuthSession() {
        return await fetchAuthSession();
    }
    async beginProviderSignIn(provider) {
        await signInWithRedirect({
            provider: provider,
        });
    }
    async beginSignIn(username) {
        let isNewUser = true;
        try {
            const signUpResult = await signUp({
                username,
                password: window.crypto.randomUUID() + "Az!",
            });
            if (signUpResult.isSignUpComplete) {
                console.debug("email/phone signup confirmed. begin signin");
            }
            else {
                throw new Error("failed to signup: " + signUpResult.nextStep.signUpStep);
            }
        }
        catch (error) {
            if (error instanceof Error && error.name === "UsernameExistsException") {
                isNewUser = false;
            }
            else {
                throw error;
            }
        }
        const signInResult = await signIn({
            username,
            options: {
                authFlowType: "CUSTOM_WITHOUT_SRP",
            },
        });
        if (signInResult.nextStep.signInStep !==
            "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE") {
            throw new Error("failed to signin: " + signInResult.nextStep.signInStep);
        }
        return { signInResult, isNewUser };
    }
    async confirmSignIn(code) {
        try {
            const confirmSignInResult = await confirmSignIn({
                challengeResponse: code,
            });
            if (confirmSignInResult.isSignedIn === false &&
                confirmSignInResult.nextStep.signInStep ===
                    "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE") {
                return "wrong-code";
            }
            else if (confirmSignInResult.nextStep.signInStep === "DONE") {
                return "success";
            }
            else {
                throw new Error(confirmSignInResult.nextStep.signInStep);
            }
        }
        catch (error) {
            if (error instanceof Error &&
                (error.name === "UserLambdaValidationException" ||
                    error.name === "NotAuthorizedException")) {
                return "max-attempts-exceeded";
            }
            throw error;
        }
    }
    async signOut() {
        await signOut();
    }
}
